import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { SessionService } from 'src/app/services/session.service';
import { environment } from 'src/environments/environment';
import { IDeclarationsDataModel, IFinalizeNotificationModel, IFinalizeNotificationResponseModel } from '../models/veg-wizard-models';
import { Logger } from './logger-service';

@Injectable({
  providedIn: 'root'
})
export class DeclarationsService {

  constructor(
    private http: HttpClient,
    private logger: Logger,
    private sessionService: SessionService
  ) { }

  setDeclarations$(model: IDeclarationsDataModel, sessionId: string): Observable<boolean> {

    return this.http.post<boolean>(
      `${environment.apiUrl}/session/set-declarations`, { ...model, sessionKey: sessionId })
      .pipe(
        catchError((err: HttpErrorResponse) => {
          this.logger.error('setSelfAudit error', err);
          return of(false)
        }),
        map(() => true) // return true, as it should be HttpStatusCode OK
      );
  }

  finalizeNotification$(sessionId: string ): Observable<IFinalizeNotificationResponseModel> {

    if (sessionId == null) {
      throw new Error('Session key not found.');
    }

    const modelForPost = { sessionKey: sessionId } as IFinalizeNotificationModel;

    const url = `${environment.apiUrl}/session/finalize-notification`;
    return this.http.post<IFinalizeNotificationResponseModel>(url, modelForPost);

  }
}
